import React from 'react';
import { FaMapMarkerAlt } from 'react-icons/fa';
import SITE from '../../Data/siteConfig';
import './ServiceAreas.css';

const ServiceAreas = () => {
  return (
    <section className="service-areas section section-muted" aria-labelledby="areas-heading">
      <div className="section-inner">
        <div className="section-header">
          <h2 id="areas-heading" className="section-title">Bursa&apos;nın Her Yerinde Teknik Servis</h2>
          <p className="section-subtitle">
            Osmangazi merkezli ekibimiz Bursa geneline hızlı ulaşım sağlar.
            Bölgenizde kombi, klima veya beyaz eşya servisi için bizi arayın.
          </p>
        </div>

        <ul className="areas-grid" aria-label="Hizmet verilen bölgeler">
          {SITE.serviceAreas.map((area) => (
            <li className="area-chip" key={area}>
              <FaMapMarkerAlt className="area-chip-icon" />
              {area}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default ServiceAreas;
